import type { ProductChoicesListType } from '@virginexperiencedays/products/src/types';

import { Image } from '../../../layout/Image';
import { LinkWrap } from '../../../navigation/LinkWrap';
import { DisplayHeading } from '../../../typography/DisplayHeading';

type productChoicesListProps = {
  productChoicesList: ProductChoicesListType[];
  baseURL: string;
  onClick?: (data: { title: string }) => void;
};

const ProductChoiceItem = ({ slug, title, mainImageUrl, mainImageAltText, baseURL, onClick }) => {
  return (
    <li>
      <LinkWrap
        className="text-neutral-strong hover:text-link relative flex items-center break-words text-sm font-semibold leading-normal"
        href={`${baseURL}/product/${slug}`}
        key={slug}
        prefetch={false}
        onClick={() => onClick({ title })}
      >
        <>
          <Image
            className="image:object-cover mr-2 h-20 w-20 overflow-hidden rounded"
            fill
            src={mainImageUrl}
            sizes="80px"
            alt={mainImageAltText}
          />
          <DisplayHeading size="5" as="h3" className="flex-1 font-semibold leading-normal">
            {title}
          </DisplayHeading>
        </>
      </LinkWrap>
    </li>
  );
};

export const ProductChoicesGrid = ({
  productChoicesList,
  baseURL,
  onClick,
}: productChoicesListProps) => {
  return (
    <ul className="flex flex-col flex-wrap gap-4 pt-8 md:grid md:grid-cols-2 md:grid-rows-1 lg:grid-cols-3">
      {productChoicesList.map((product) => {
        return (
          <ProductChoiceItem key={product.title} {...product} baseURL={baseURL} onClick={onClick} />
        );
      })}
    </ul>
  );
};
